export enum ReauthChallengeErrorCode {
  StepUpRequired = 'STEP_UP_REQUIRED',
  InvalidCode = 'INVALID_CODE',
  TooManyAttempts = 'TOO_MANY_ATTEMPTS',
  CodeNotFound = 'CODE_NOT_FOUND',
  CodeExpired = 'CODE_EXPIRED',
  WaitToSendCode = 'WAIT_TO_SEND_CODE',
}

const REAUTH_CHALLENGE_ERROR_CODES = Object.values(ReauthChallengeErrorCode);

interface GraphQLErrorResponse {
  data?: {
    errors?: Array<{
      extensions?: {
        code?: string;
        otpCode?: string;
      };
    }>;
  };
}

export const reauthChallengeErrorHandler = (
  response: GraphQLErrorResponse,
): ReauthChallengeErrorCode | null => {
  const error = response?.data?.errors?.[0];

  if (!error) return null;
  const code = error?.extensions?.code;

  if (code && REAUTH_CHALLENGE_ERROR_CODES.includes(code as ReauthChallengeErrorCode)) {
    return code as ReauthChallengeErrorCode;
  }

  return null;
};

export const getCodeError = (response: GraphQLErrorResponse): string | null => {
  const error = response?.data?.errors?.[0];

  if (!error) return null;
  const code = error?.extensions?.code;

  return code || null;
};
